__webpack_require__.p = "/label-parser-frontend/";